const ImprintPage = (props) => {
    const defClass = 'flex mb-4 text-xl'

    return (
        <div className={'Page'}>
            <div className={'px-4 pt-4 mb-4'}>
                <div className={'w-full justify-start'}>
                    <div className={defClass}>
                        • We have not ordered additional servers directly
                        supporting NFTHive this month, but we have improved our
                        blockproducer infra:
                    </div>
                    <div className={defClass}>
                        • New mainnet producer with down to 0.1 ms response time
                    </div>
                    <div className={defClass}>
                        • New P2P Node with full blocks log
                    </div>
                    <div className={defClass}>
                        <div className={'flex flex-wrap'}>
                            <div className={'w-full ml-4'}>
                                • Frontend team is working on a new market
                                overview, inventory, which is almost done:
                            </div>
                            <div className={'w-full ml-4'}>
                                - Collapsable Side Filter Bar
                            </div>
                            <div className={'w-full ml-4'}>
                                - Mobile Modal Filters
                            </div>
                            <div className={'w-full ml-4'}>
                                - Slicker, cleaner Cards
                            </div>
                            <div className={'w-full ml-4'}>- Preview:</div>
                            <img
                                className={'w-200'}
                                src={'/frontend-update.png'}
                            />
                        </div>
                    </div>
                    <div className={defClass}>
                        • Currently also designing a new Trading Overview to
                        include private buy offers, to catch up with Atomichub
                        features
                    </div>
                    <div className={defClass}>
                        • Discussed the new public buy offers with the wombat
                        team
                    </div>
                    <div className={defClass}>
                        • We are integrating the new buy offer system on testnet
                        and will support template order books
                    </div>
                    <div className={defClass}>
                        • Agreed to new atomicmarket tokenomics model that use
                        1% fees to buy back wombat, nefty and honey
                    </div>
                    <div className={defClass}>
                        • Still saving up funds for server expansion. Systems
                        are currently working fine and we have a lot of
                        development to do. So further expansion is planned for
                        Q1 2024
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ImprintPage
